export default __webpack_public_path__ + "static/media/cp_geo_mw.8e62aef0.svg";